import { assertNever } from 'owa-assert';
import type { OutlookSpaceId, ProjectId } from 'owa-timestream-types';

export default function getProjectIdInfo(
    projectId: ProjectId
): {
    tenant: string;
    mailbox: string;
    outlookSpaceId: OutlookSpaceId;
    isShared: boolean;
} {
    const info = projectId.split('/');
    if (info.length == 1) {
        return {
            tenant: '',
            mailbox: '',
            outlookSpaceId: info[0] as OutlookSpaceId,
            isShared: false,
        };
    } else if (info.length == 3) {
        return {
            tenant: info[0],
            mailbox: info[1],
            outlookSpaceId: info[2] as OutlookSpaceId,
            isShared: true,
        };
    } else {
        return assertNever(`invalid projectId ${projectId}` as never);
    }
}
